import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import HomePage from "@/pages/HomePage";
import ModalityPage from "@/pages/ModalityPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import "@/App.css";

function SiteLayout({ children }) {
  return (
    <>
      <Header />
      {children}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route
            path="/"
            element={
              <SiteLayout>
                <HomePage />
              </SiteLayout>
            }
          />
          <Route
            path="/mobile"
            element={
              <SiteLayout>
                <ModalityPage modalityKey="mobile" />
              </SiteLayout>
            }
          />
          <Route
            path="/pc"
            element={
              <SiteLayout>
                <ModalityPage modalityKey="pc" />
              </SiteLayout>
            }
          />
          <Route
            path="/consola"
            element={
              <SiteLayout>
                <ModalityPage modalityKey="consola" />
              </SiteLayout>
            }
          />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <SiteLayout>
                <AdminDashboardPage />
              </SiteLayout>
            }
          />
        </Routes>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
              borderRadius: "0",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
